<template>
<span>
    <pakhsh-details></pakhsh-details>
    <page-footer></page-footer>
</span>
</template>
<script>
import PakhshDetails from '@/components/moduls/PakhshDetails';
import PageFooter from '@/components/PageFooter';
export default {
    name :'optic',
    components:{
        PakhshDetails,
        PageFooter
    }

    
};
</script>


